const VAT_DEFAULT = 0.22;
const VAT_RATES: { [key: number]: number } = {
    2023: 0.2,
};

export const getVAT = () => VAT_RATES[new Date().getFullYear()] ?? VAT_DEFAULT;
